var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccomMotel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 43,
    viewBox: "0 0 27 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9905 0L22.4898 3.73705H26.9877L23.2395 6.73558L24.7388 11.2335L20.9905 8.23489L17.2423 11.2335L18.7416 6.73558L14.9933 3.73705H19.4912L20.9905 0Z",
    fill: "#6DDFE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99716 0L7.49647 3.73705H11.9944L8.24612 6.73558L9.74543 11.2335L5.99716 8.23489L2.24897 11.2335L3.74819 6.73558L0 3.73705H4.49784L5.99716 0Z",
    fill: "#6DDFE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000488281 42.1662V15.1787H4.57337L13.4942 33.0954L22.4151 15.1787H26.988V42.1662H22.2277V26.0487L14.3938 42.1662H12.5946L4.76078 26.0487V42.1662H0.000488281Z",
    fill: "#6DDFE2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccomMotel);
export default __webpack_public_path__ + "static/media/accom_motel.8c6c2a7082850ba6061ec108a8358c84.svg";
export { ForwardRef as ReactComponent };